import * as constants from '../constants/v2_training_modules'

const defaultState = {
  v2TrainingModule: {},
  v2TrainingModules: [],
  requestType: '',
  requestSuccess: false,
  createError: null,
  updateError: null
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case constants.GET_V2_TRAINING_MODULES_REQUEST:
      newState.requestType = constants.GET_V2_TRAINING_MODULES_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_V2_TRAINING_MODULES_SUCCESS:
      newState.requestType = action.type;
      newState.v2TrainingModules = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_V2_TRAINING_MODULES_FAILURE:
      newState = defaultState;
      return newState;
    case constants.CREATE_V2_TRAINING_MODULE_REQUEST:
      newState.requestType = constants.CREATE_V2_TRAINING_MODULE_REQUEST;
      newState.requestSuccess = false;
      newState.createError = null;
      return newState;
    case constants.CREATE_V2_TRAINING_MODULE_SUCCESS:
      newState.requestType = action.type;
      newState.v2TrainingModule = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.CREATE_V2_TRAINING_MODULE_FAILURE:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      newState.createError = action.exception.response.data.error;
      return newState;
    case constants.UPDATE_V2_TRAINING_MODULE_REQUEST:
      newState.requestType = constants.UPDATE_V2_TRAINING_MODULE_REQUEST;
      newState.requestSuccess = false;
      newState.updateError = null;
      return newState;
    case constants.UPDATE_V2_TRAINING_MODULE_SUCCESS:
      newState.requestType = action.type;
      newState.requestSuccess = true;
      newState.v2TrainingModule = action.body;
      return newState;
    case constants.UPDATE_V2_TRAINING_MODULE_FAILURE:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      newState.updateError = action.exception.response.data.error;
      return newState;
    case constants.ARCHIVE_V2_TRAINING_MODULE_REQUEST:
      newState.requestType = action.type;
      newState.requestType = constants.ARCHIVE_V2_TRAINING_MODULE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.ARCHIVE_V2_TRAINING_MODULE_SUCCESS:
      newState.requestType = action.type;
      newState.requestSuccess = action.body;
      return newState;
    case constants.ARCHIVE_V2_TRAINING_MODULE_FAILURE:
      newState.requestType = action.type;
      return newState
    case constants.UNARCHIVE_V2_TRAINING_MODULE_REQUEST:
      newState.requestType = constants.UNARCHIVE_V2_TRAINING_MODULE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UNARCHIVE_V2_TRAINING_MODULE_SUCCESS:
      newState.requestType = action.type;
      newState.requestSuccess = action.body;
      return newState;
    case constants.UNARCHIVE_V2_TRAINING_MODULE_FAILURE:
      newState.requestType = action.type;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/v2_training_modules.js